<template>
    <div class="main theme-light">

        <div class="animated fadeIn">

            <div v-if="loading">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>
            <div>
                <div v-if="reportData" id="print-page-top" :class="reportThemeStyle">
                    <b-row>
                        <b-col md=1></b-col>
                        <b-col md=10>

                            <!-- 月報 -->
                            <div v-if="reportData.type == 'monthly'">
                                <!-- <Monthly-1 :report_data="reportData" :user="userInfo" :timezone="timezone"></Monthly-1> -->
                                <Monthly-1 v-if="reportData.version == 1.0" :report_data="reportData" :user="userInfo" :timezone="timezone"></Monthly-1>
                                <Monthly-0 v-else :report_data="reportData" :user="userInfo" :timezone="timezone"></Monthly-0>
                            </div>


                            <!-- 特製履歷報：婚禮 -->
                            <div v-if="reportFormat == 'wedding'">
                                <Period_Wedding v-if="reportData.type == 'period'" :report_data="reportData" :user="userInfo" :timezone="timezone"></Period_Wedding>
                            </div>

                            <!-- 完整履歷報 -->
                            <div v-else-if="reportData.type == 'period'">
                                <!-- xlab 開發測試 -->
                                <!-- <template v-if="$config.getHostType() == 'xlab'">

                                </template> -->
                                <template v-if="reportData.version == 1.0">
                                    <Period-1 :report_data="reportData" :user="userInfo" :timezone="timezone"></Period-1>
                                </template>
                                <template v-else>
                                    <Period-0 v-if="reportData.type == 'period'" :report_data="reportData" :user="userInfo" :timezone="timezone"></Period-0>
                                </template>
                            </div>

                        </b-col>
                        <!-- <b-col md=1></b-col> -->
                    </b-row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TestData from '@/testData/testData'
import axios from 'axios'
import AgriLoading from '@/views/components/AgriLoading'
import Monthly_0_0 from '@/views/project/report/Monthly_0.0'
import Monthly_1_0 from '@/views/project/report/Monthly_1.0'
import Period_0_0 from '@/views/project/report/Period_0.0'
import Period_1_0 from '@/views/project/report/Period_1.0'
import Period_Wedding from '@/views/project/report/Period_Wedding'

export default {
    components: {
        AgriLoading,
        'Monthly-0':  Monthly_0_0,
        'Monthly-1':  Monthly_1_0,
        'Period-0':   Period_0_0,
        'Period-1':   Period_1_0,
        Period_Wedding,
    },
    data () {
        return {
            loading: false,
            timezone: 'Asia/Taipei',
            reportData: undefined,
            userInfo: undefined,
            // Admin
            deIdentification: false,    // Admin 用的去識別化遮罩
            // Test
            useTestData: false,         // 開發期間使用測試資料用
        }
    },
    mounted ()
    {
        this.timezone = this.$tools.date.getTimezoneNow();

        if ( localStorage.token != undefined )
        {
            // console.log( 'localStorage.token' )
            // console.log( localStorage.token )

            this.$store.dispatch('user/getUserProfile')
                .then(res => {
                    //console.log('取得使用者資料：HeaderAccount');
                    this.$toastr.i( this.$t('other.toastr_welcome') , this.$t('other.toastr_hi') + this.user_first_name);

                    // 使用者語言可能會覆蓋掉網址列指定的語言，所以此處要再次指定語言
                    if ( this.$route.query.lang != undefined )
                    {
                        let newLang = this.$route.query.lang
                        switch (newLang)
                        {
                            case 'zh-Hant-TW': break;
                            default: newLang = 'en'; break;
                        }
                        this.$i18n.locale = newLang;
                        localStorage.setItem('locale', newLang);
                        this.$store.commit('user/setLanguage', newLang)
                        // console.log( 'user: ' + localStorage.locale )
                    }
                })
                .catch(err => {
                    //console.log('取得使用者資料：HeaderAccount 失敗');
                })
        }

        // 報告連結的資料帶在 params url 內，網址上是看不到的
        this.get_Report_Data( this.$route.params.url )
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'user_first_name': state => state.user.first_name,
        }),

        reportThemeStyle ()
        {
            if ( this.reportData && this.reportData.type == 'period' )
            {
                if ( this.reportData.version == 1.0 ) return 'report-theme-dark'
            }

            return ''
        },

        reportFormat ()
        {
            return this.$route.query.format
        },
    },
    methods: {

        get_Report_URL ()
        {
            let _report_hashID = undefined

            // 使用 id 串接報告 hashid 的話，正常顯示
            if ( this.$route.query.id != undefined )
            {
                _report_hashID = this.$route.query.id
                this.deIdentification = false
            }
            // 使用 ids 串接報告 hashid 的話，要將資料進行去識別化
            else if ( this.$route.query.ids != undefined )
            {
                _report_hashID = this.$route.query.ids
                this.deIdentification = true
            }


            if ( _report_hashID != undefined )
            {
                this.loading = true
                const options = {
                    method: 'GET',
                    url: this.$config.getAPI_URL('Get_Report_URL', { reportID: _report_hashID }),
                }
                this.$http(options)
                    .then(res => {
                        this.loading = false

                        this.get_Report_Data( res.data.url);
                        this.userInfo = res.data.user;

                    })
                    .catch(err => {
                        this.loading = false

                        this.$router.push({
                            name: 'Page404'
                        }) // 導向 404

                    })
            }

        },

        get_Report_Data (dataURL)
        {
            if ( this.useTestData )
            {
                // console.log( TestData.Report_Monthly_1_0 )
                this.reportData = TestData.Report_Monthly_1_0
            }
            else if ( dataURL != undefined )
            {
                this.loading = true

                axios.get( dataURL )
                .then( res => {

                    if ( this.deIdentification == true )
                    {
                        this.reportData = this.get_De_Identification_Data( res.data )
                    }
                    else
                    {
                        this.reportData = res.data
                    }
                    this.loading = false
                    // console.log( res.data )
                })
                .catch( err => {
                    this.loading = false

                })
            }
            else
            {
                this.get_Report_URL()
            }
        },

        // 對撈到的報告資料做簡單遮罩，去識別化
        get_De_Identification_Data (originalData)
        {
            let _de_identification = originalData
            if ( _de_identification.cropperiod_meta )
            {
                // cropperiod
                _de_identification.cropperiod_meta.id = 99999999
                _de_identification.cropperiod_meta.uuid = '88888888-4444-4444-4444-999999999999'
                _de_identification.cropperiod_meta.name = '阿龜範例期作'
                _de_identification.cropperiod_meta.farm_field = '阿龜實驗農場'
                _de_identification.cropperiod_meta.description = '阿龜實驗農場是龜蜜們進行實驗的小小開心農場，阿龜範例期作為龜蜜們在阿龜實驗農場栽種神祕作物的種植觀察紀錄。'
                _de_identification.cropperiod_meta.pic = this.$config.checkURL('cropperiod')
                // project
                _de_identification.cropperiod_meta.project_id = 99999999
                _de_identification.cropperiod_meta.project_name = '阿龜案場'
                _de_identification.cropperiod_meta.project_description = '阿龜案場在一個神祕的地方。'
                _de_identification.cropperiod_meta.project_pic = this.$config.checkURL('cropperiod')
                _de_identification.cropperiod_meta.project_logo = this.$config.checkURL('logo')
                _de_identification.cropperiod_meta.project_timezone = 'Asia/Taipei'
            }
            // Device
            if ( _de_identification.devices )
            {
                let _weatherbox_count = 0
                let _device_count = 0
                for (let _hashID in _de_identification.devices)
                {
                    let _device = _de_identification.devices[ _hashID ]
                    if ( _device.type == 'weatherbox' )
                    {
                        _weatherbox_count += 1
                        _device.nickname = '阿龜氣象站 ' + _weatherbox_count
                    }
                    else
                    {
                        _device_count += 1
                        _device.nickname = '阿龜感測器 ' + _device_count
                    }
                    let _random = (Math.random()/10).toFixed(4)
                    _device.latitude    = parseFloat( 23.5832 + parseFloat( _random ) ).toFixed(4)
                    _device.longitude  = parseFloat( 120.5825 + parseFloat( _random ) ).toFixed(4)
                    _device.description = null
                }
            }

            return _de_identification
        },
    }
}
</script>

<style lang="scss">

.report-theme-dark
{
    color: white;
    background-color: #222222;

    .card {
        border-color: rgb(39, 76, 71);
    }
}

</style>
